import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { derniersCompteursCv, ecouterCompteursCv, lireCompteursCv } from '../compteurs-cv';

/**
 * Lien de navigation « CV à rattacher » (rôle rh) avec le nombre de CV à
 * confirmer. Les compteurs sont relus à chaque changement d'écran — jamais en
 * boucle ici : seule la page les relit pendant une analyse, et les publie.
 */
export function LienCvARattacher() {
  const { pathname } = useLocation();
  const [aConfirmer, setAConfirmer] = useState<number>(derniersCompteursCv()?.aRattacher ?? 0);

  useEffect(() => ecouterCompteursCv((compteurs) => setAConfirmer(compteurs.aRattacher)), []);

  useEffect(() => {
    // Hors ligne ou refus : le lien reste, sans nombre à jour.
    lireCompteursCv().catch(() => undefined);
  }, [pathname]);

  return (
    <NavLink to="/cv-a-rattacher">
      CV à rattacher
      {aConfirmer > 0 && (
        <span className="compteur-nav">
          {aConfirmer}
          <span className="visuellement-cache"> à confirmer</span>
        </span>
      )}
    </NavLink>
  );
}
